import { Alert, AlertTitle } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

function AlertLabel({ isShow, isCorrect, successText, errorText }) {
  const alertData = isCorrect
    ? { severity: 'success', title: 'Успешно', text: successText }
    : { severity: 'error', title: 'Ошибка', text: errorText };

  if (!isShow) return null;

  return (
    <Alert sx={{ width: '100%' }} severity={alertData.severity}>
      <AlertTitle>{alertData.title}</AlertTitle>
      {alertData.text}
    </Alert>
  );
}

AlertLabel.propTypes = {
  isShow: PropTypes.bool.isRequired,
  isCorrect: PropTypes.bool.isRequired,
  successText: PropTypes.string,
  errorText: PropTypes.string,
};

AlertLabel.defaultProps = {
  successText: 'Данные успешно сохранены',
  errorText: 'Произошла ошибка',
};

export default AlertLabel;
